import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSPrescriptionTemplateServices {

    static getAllTemplatesByPharmacyId(pharmacyId, params) {
        return axios.get(`${URL.PMS_GET_ALL_PRESCRIPTION_TEMPLATES}/${pharmacyId}`, {
            ...PMSPrescriptionTemplateServices.getAuthHeader(),
            params,
        });
    }

    static getTemplateById(pharmacyId, id) {
        return axios.get(`${URL.PMS_GET_PRESCRIPTION_TEMPLATE_BY_ID}/${id}/${pharmacyId}`, PMSPrescriptionTemplateServices.getAuthHeader());
    }

    static createTemplate(pharmacyId, data) {
        return axios.post(`${URL.PMS_CREATE_PRESCRIPTION_TEMPLATE}/${pharmacyId}`, data, PMSPrescriptionTemplateServices.getAuthHeader());
    }

    static updateTemplateById(pharmacyId, id, data) {
        return axios.put(`${URL.PMS_UPDATE_PRESCRIPTION_TEMPLATE}/${id}/${pharmacyId}`, data, PMSPrescriptionTemplateServices.getAuthHeader());
    }

    static deleteTemplateById(pharmacyId, id) {
        return axios.delete(`${URL.PMS_DELETE_PRESCRIPTION_TEMPLATE}/${id}/${pharmacyId}`, PMSPrescriptionTemplateServices.getAuthHeader());
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
